import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import {
  Group
} from '@mui/icons-material';
import TeamView from './TeamView';

interface EpicInsightsViewProps {
  epics: any[];
  aggregatedInsights: any;
  loading?: boolean;
}

const EpicInsightsView: React.FC<EpicInsightsViewProps> = ({
  epics,
  aggregatedInsights,
  loading = false
}) => {

  return (
    <Box>
      <Box sx={{ mb: 1.5 }}> {/* Reduced margin */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}> {/* Reduced margin */}
          <Group sx={{ mr: 0.75, color: 'primary.main', fontSize: 20 }} /> {/* Smaller icon and margin */}
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Team View
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}> {/* Smaller font */}
          Team workload distribution and capacity analysis
        </Typography>
      </Box>

      <TeamView
        epics={epics}
        aggregatedInsights={aggregatedInsights}
        loading={loading}
      />
    </Box>
  );
};

export default EpicInsightsView;
